import React from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTranslation } from "react-i18next";
import { getCountriesSuccess } from "redux/actions/appActions";
import { getCountryDetails } from "services";

const useStyles = makeStyles((theme) => ({
  color: {
    color: theme.grey,
  },
  formHelperText: {
    fontSize: 10,
    paddingLeft: 6,
  },
}));

export const CountryLookup = (props) => {
  const { onChangeFunction, countryCode, filterCountry } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  let countryOptions;
  let selectedIndex;
  const dispatch = useDispatch();
  const appConfig = useSelector((state) => state.appConfig);

  if (appConfig && appConfig.countries !== null) {
    countryOptions = appConfig.countries;
  } else {
    getCountryDetails().then((data) => {
      if (data) {
        countryOptions = data;
        dispatch(getCountriesSuccess(data));
      }
    });
  }

  if (countryOptions) {
    if (filterCountry) {
      countryOptions = countryOptions.filter(
        (item) => item?.countryName != filterCountry
      );
    }

    if (countryCode) {
      selectedIndex = countryOptions.findIndex((option) => {
        return option.id == countryCode;
      });
    }
  }
  

  return (
    <>
      {countryOptions && (
        <Autocomplete
          options={countryOptions}
          getOptionLabel={(option) => option && option.countryName}
          id="country"
          classes={{ inputRoot: classes.color }}
          defaultValue={countryOptions[selectedIndex]}
          onBlur={onChangeFunction}
          onChange={onChangeFunction}
          InputProps={{ className: classes.color }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("other.tlOperationalCountry")}
              FormHelperTextProps={{
                className: classes.formHelperText,
              }}
            />
          )}
        />
      )}
    </>
  );
};

CountryLookup.propTypes = {
  onChangeFunction: PropTypes.func.isRequired,
  countryCode: PropTypes.string,
  filterCountry: PropTypes.string,
};

export default CountryLookup;
